export default {
 
 /*   people(state,getters) {
        return state.transfer.people
    },
    date(state,getters) {
        return state.transfer.date
    },
    time(state,getters) {
        return state.transfer.time
    },
    from_model(state,getters) {
        return state.transfer.from
    },
    to_model(state,getters) {
        return state.transfer.to
    },
    current_step(state,getters) {
        return state.transfer.current_step
    }
    */
}